<template>
  <ModalContainer
    modalTitle="Partial result warning"
    closeBtnText="Close"
    widthOnDesktop="40rem"
    @closeModal="closeMismatchModal"
  >
    <template slot="body">
      <div>
        This system shows the state of routing alignment for the first
        {{ truncatedPrefixNumber }} prefixes announced by the AS, a limit which
        will be removed in later versions.
      </div>
    </template>
  </ModalContainer>
</template>

<script>
import ModalContainer from '../ui/ModalContainer.vue';

export default {
  name: 'TruncatedResponseModal',
  components: {
    ModalContainer
  },
  props: {
    truncatedPrefixNumber: {
      type: Number,
      required: true
    }
  },
  methods: {
    closeMismatchModal() {
      this.$emit('closeModal');
    }
  }
};
</script>

<style lang="scss" scoped></style>
